import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DraftIcon from "../assets/svg/draft-svgrepo-com.svg";
import { useNavigate } from "react-router-dom";
import "./batchInfoTable.scss";
import ProgressBar from "./ProgressBar";
import BasicModal from "../components/Modal/JsonModal/DocumentDetailModal";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../redux/administrator/actions";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "./Snackbars/CustomizedSnackbars";
import SearchBar from "./Controls/SearchBar/SearchBar";
import DashboardTableSkaleton from "./Skeletons/DashboardTableSkaleton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { adminRoutes } from "../routes/routeConstants";
import Buttons from "./Controls/Buttons/Button";

function Row(props) {
  const [openModal, setOpenModal] = useState(false);
  const [batchRecords, setBatchRecords] = useState([]);
  const [open, setOpen] = useState(false);
  const { row, confirmDelete } = props;
  const navigate = useNavigate();
  const showJsonModal = (list) => {
    setBatchRecords(list);

    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const showHistoryData = (payload) => {
    localStorage.setItem("batch_id", payload);
    navigate(`/${adminRoutes.dataHistory}`, {
      state: payload,
    });
  };

  return (
    <>
      {openModal && (
        <BasicModal
          isOpenModal={openModal}
          handleClose={closeModal}
          data={batchRecords}
        />
      )}
      <TableRow key={row?.project_id}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          style={{
            maxWidth: "150px",
            wordBreak: "break-all",
          }}
        >
          {row.project_name}
        </TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <Tooltip title="Delete Project">
          <IconButton onClick={() => confirmDelete("project", row?.project_id)}>
            <DeleteTwoToneIcon />
          </IconButton>
        </Tooltip>
      </TableRow>

      {open &&
        row?.batch_details?.map((list) => {
          return (
            <>
              <TableRow className="hidden-row">
                <TableCell>{}</TableCell>
                <TableCell>{}</TableCell>
                <TableCell
                  style={{
                    maxWidth: "150px",
                    wordBreak: "break-all",
                  }}
                >
                  {list.batch_name}
                </TableCell>
                <TableCell>{list.pre_processor}</TableCell>
                <TableCell>{list.processor}</TableCell>
                <TableCell>{list.validator}</TableCell>
                <TableCell>{list.status} </TableCell>
                {list.show_data === true ? (
                  <TableCell>
                    <img
                      className="img"
                      src={DraftIcon}
                      onClick={() => showJsonModal(list.documents_dict)}
                      alt="Draft Icon"
                    />
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )}
                {list?.status !== "Validation Completed" ? (
                  <TableCell>
                    {/* <Link to="/extraction-details"> */}

                    <IconButton onClick={() => showHistoryData(list.batch_id)}>
                      <VisibilityIcon />
                    </IconButton>
                    {/* </Link> */}
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )}
                <TableCell>
                  <Tooltip title="Delete Batch">
                    <IconButton
                      onClick={() => confirmDelete("batch", list.batch_id)}
                    >
                      <DeleteTwoToneIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </>
          );
        })}
    </>
  );
}

export default function DashboardTable(props) {
  const { header } = props;
  const batch_details = useSelector((state) => state?.admin?.batchDetails);
  const [pageCount, setPageCount] = useState(batch_details?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [projects, setProjects] = useState([]);
  const dispatch = useDispatch();

  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const handleDeleteBatchLogs = useSelector(
    (state) => state?.admin?.handleDeleteBatchLogs
  );
  const handleDeleteProjectLogs = useSelector(
    (state) => state?.admin?.handleDeleteProjectLogs
  );

  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true) {
        setLoader(true);
        setMessage(apiStatus?.message);
        setErr(true);
      } else if (apiStatus?.apiSuccess === true) {
        setLoader(false);
        dispatch(acts.clearApiStatus());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  useEffect(() => {
    if (batch_details?.response_list?.length > 0) {
      setProjects(batch_details?.response_list);
      setPageCount(batch_details?.total_count);
      setRowsPerPage(rowsPerPage);
      // setPageCount(batch_details?.total_count);
    }
  }, [batch_details]);

  useEffect(() => {
    dispatch(
      acts.getBatchDetailsList({
        page: page + 1,
        page_size: rowsPerPage,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, rowsPerPage]);

  useEffect(() => {
    if (handleDeleteBatchLogs && handleDeleteBatchLogs !== undefined) {
      if (
        handleDeleteBatchLogs?.notification === true &&
        handleDeleteBatchLogs.apiSuccess === true &&
        handleDeleteBatchLogs?.loader === false
      ) {
        dispatch(acts.handleClearDeleteBatchLogs());
        setMessage(handleDeleteBatchLogs?.message);
        setSuccess(true);
        dispatch(
          acts.getBatchDetailsList({
            page: page + 1,
            page_size: rowsPerPage,
          })
        );
      } else if (
        handleDeleteBatchLogs?.notification === false &&
        handleDeleteBatchLogs.apiSuccess === false &&
        handleDeleteBatchLogs?.loader === false &&
        handleDeleteBatchLogs?.apiError === true
      ) {
        dispatch(acts.handleClearDeleteBatchLogs());
        setMessage(handleDeleteBatchLogs?.message);
        setErr(true);
        dispatch(
          acts.getBatchDetailsList({
            page: page + 1,
            page_size: rowsPerPage,
          })
        );
      }
    }
  }, [handleDeleteBatchLogs]);

  useEffect(() => {
    if (handleDeleteProjectLogs && handleDeleteProjectLogs !== undefined) {
      if (
        handleDeleteProjectLogs?.notification === true &&
        handleDeleteProjectLogs.apiSuccess === true &&
        handleDeleteProjectLogs?.loader === false
      ) {
        dispatch(acts.handleClearDeleteProjectLogs());
        setMessage(handleDeleteProjectLogs?.message);
        setSuccess(true);
        dispatch(
          acts.getBatchDetailsList({
            page: page + 1,
            page_size: rowsPerPage,
          })
        );
      } else if (
        handleDeleteProjectLogs?.notification === false &&
        handleDeleteProjectLogs.apiSuccess === false &&
        handleDeleteProjectLogs?.loader === false &&
        handleDeleteProjectLogs?.apiError === true
      ) {
        dispatch(acts.handleClearDeleteProjectLogs());
        setMessage(handleDeleteProjectLogs?.message);
        setErr(true);
        dispatch(
          acts.getBatchDetailsList({
            page: page + 1,
            page_size: rowsPerPage,
          })
        );
      }
    }
  }, [handleDeleteProjectLogs]);

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      acts.getBatchDetailsList({
        page: value + 1,
        page_size: rowsPerPage,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const onSearch = (word, type) => {
    let result;
    let filteredProjects = [];
    // Trim leading and trailing spaces from the search term
    const trimmedWord = word.trim();

    if (
      !batch_details?.response_list ||
      !Array.isArray(batch_details.response_list)
    ) {
      setProjects([]);
      return;
    }

    if (type === "project") {
      if (trimmedWord) {
        result = batch_details?.response_list?.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(trimmedWord.toLowerCase()) !== -1
          );
        });
      } else {
        result = batch_details?.response_list;
      }
    } else {
      if (trimmedWord) {
        batch_details?.response_list?.map((item, index) => {
          const filteredBatches = item?.batch_details?.filter(function (el) {
            return (
              el?.batch_name
                .toString()
                .toLowerCase()
                .indexOf(trimmedWord.toLowerCase()) !== -1
            );
          });
          if (filteredBatches.length > 0) {
            filteredProjects.push({
              ...batch_details?.response_list[index],
              batch_details: filteredBatches,
            });
          }
        });
        result = filteredProjects;
      } else {
        result = batch_details?.response_list;
      }
    }
    setProjects(result);
  };

  const onClickDeleteBatchLogs = (batchId) => {
    dispatch(acts.deleteBatchLogs(batchId));
  };

  const onClickDeleteProjectLogs = (projectId) => {
    dispatch(acts.deleteProjectLogs(projectId));
  };

  const confirmDelete = (type, id) => {
    setDeleteType(type);
    setDeleteTarget(id);
    setConfirmOpen(true);
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    setDeleteTarget(null);
    setDeleteType("");
  };

  const handleConfirmDelete = () => {
    if (deleteType === "batch") {
      dispatch(acts.deleteBatchLogs(deleteTarget));
    } else if (deleteType === "project") {
      dispatch(acts.deleteProjectLogs(deleteTarget));
    }
    handleConfirmClose();
  };

  return (
    <div className="Admin-BatchInfo-wrap">
      <Grid container className="batchInfo-action-wrap">
        <Grid item md={4}>
          <SearchBar onSearch={(value, type) => onSearch(value, type)} />
        </Grid>
      </Grid>
      <Box className="Admin-BatchInfo">
        {apiStatus?.loader ? (
          <DashboardTableSkaleton />
        ) : (
          <Box className="batch-monitor-table-container">
            <TableContainer className="batchInfo-container">
              <Table
                stickyHeader
                aria-label="simple table"
                className="batch-info-table"
              >
                <TableHead>
                  <TableRow className="table-row">
                    <TableCell>{/* <Checkbox disabled /> */}</TableCell>
                    {header?.map((list) => {
                      return <TableCell>{list}</TableCell>;
                    })}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="tBody">
                  {projects &&
                    projects?.length > 0 &&
                    projects?.map((project, i) => (
                      <Row
                        key={project?.project_name}
                        row={project}
                        i={i}
                        props={props}
                        onClickDeleteBatchLogs={onClickDeleteBatchLogs}
                        onClickDeleteProjectLogs={onClickDeleteProjectLogs}
                        confirmDelete={(type, id) => confirmDelete(type, id)}
                      />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </Box>
      {loader && <ProgressBar></ProgressBar>}
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
      <Grid
        className="pagination-wrap"
        // pagination-bg
      >
        <TablePagination
          component="div"
          rowsPerPageOptions={[100, 200, 300, 500]}
          count={parseInt(pageCount)}
          page={parseInt(page)}
          onPageChange={handlePageChange}
          rowsPerPage={parseInt(rowsPerPage)}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>

      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )}

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}

      <Dialog open={confirmOpen} onClose={handleConfirmClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this{" "}
            {deleteType === "batch" ? "batch" : "project"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Buttons
            text="Cancel"
            onClick={handleConfirmClose}
            color="primary"
          ></Buttons>
          <Buttons text="Delete" onClick={handleConfirmDelete} color="error">
            Delete
          </Buttons>
        </DialogActions>
      </Dialog>
    </div>
  );
}
